module.exports = __webpack_public_path__ + "static/media/sie.62cb853d.png";